(()=>{
  const mobile=matchMedia('(max-width:760px)');
  const root=document.querySelector('[data-commission]');
  const estimate=root?.querySelector('.commission-mobile-estimate');
  mobile.addEventListener('change',()=>{const image=document.querySelector('.style-home-image');if(!mobile.matches&&image?.dataset.mobileOriginal){image.src=image.dataset.mobileOriginal;delete image.dataset.mobileOriginal;}});
  document.addEventListener('click',event=>{
    if(!mobile.matches)return;
    const menu=document.querySelector('.mobile-menu');
    if(menu?.open&&!menu.contains(event.target))menu.open=false;
    if(event.target.closest('.menu-panel a'))menu?.removeAttribute('open');
    if(event.target.closest('[data-next],[data-back]')&&root&&!root.hasAttribute('data-invitation')){
      requestAnimationFrame(()=>{
        const step=root.querySelector('[data-step]:not([hidden])');
        if(!step)return;
        const y=window.scrollY+step.getBoundingClientRect().top-(estimate?.offsetHeight||0)-20;
        window.scrollTo({top:Math.max(0,y),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      });
    }
    if(event.target.closest('[data-home-view]')){
      const image=document.querySelector('.style-home-image');
      if(image){image.dataset.mobileOriginal=image.src;const url=new URL(image.src);url.searchParams.set('width','1000');image.src=url.href;}
    }
  });
  const bar=document.querySelector('.pg-jump');
  if(bar){
    const summary=bar.querySelector('summary');
    const initial=summary?.textContent;
    const update=()=>{
      if(!summary)return;
      if(!mobile.matches){summary.textContent=initial;return;}
      const active=bar.querySelector('a[aria-current="location"]');
      const label=active?initial+' · '+active.textContent.trim():initial;
      if(summary.textContent!==label)summary.textContent=label;
    };
    new MutationObserver(update).observe(bar,{subtree:true,attributes:true,attributeFilter:['aria-current']});
    mobile.addEventListener('change',update);update();
  }
})();
(()=>{
  const section=document.querySelector('.considered');
  const rail=section?.querySelector('.painting-pair');
  if(!rail)return;
  const mobile=matchMedia('(max-width:760px)');
  const cards=[...rail.children];
  const description=section.querySelector('.considered-heading>div');
  const originalParent=description?.parentElement;
  const provenance=section.querySelector('.process-provenance');
  let controls,frame;
  function update(){
    if(!controls)return;
    const edge=rail.getBoundingClientRect().left+20;
    const distances=cards.map(card=>Math.abs(card.getBoundingClientRect().left-edge));
    const selected=distances.indexOf(Math.min(...distances));
    [...controls.children].forEach((button,index)=>button.setAttribute('aria-pressed',String(index===selected)));
  }
  function go(index){
    const card=cards[index];
    rail.scrollTo({left:rail.scrollLeft+card.getBoundingClientRect().left-rail.getBoundingClientRect().left-20,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  }
  function layout(){
    if(mobile.matches){
      if(description&&provenance){provenance.after(description);description.classList.add('sequence-description');}
      rail.tabIndex=0;rail.setAttribute('role','region');rail.setAttribute('aria-labelledby','considered-title');
      if(!controls){
        controls=document.createElement('div');controls.className='sequence-controls';
        cards.forEach((card,index)=>{const button=document.createElement('button');button.type='button';button.textContent=String(index+1).padStart(2,'0');button.setAttribute('aria-label',card.querySelector('figcaption>span').textContent.trim());button.addEventListener('click',()=>go(index));controls.append(button)});
        rail.after(controls);
      }
      requestAnimationFrame(()=>requestAnimationFrame(update));
    }else{
      if(description){originalParent.append(description);description.classList.remove('sequence-description');}
      rail.removeAttribute('tabindex');rail.removeAttribute('role');rail.removeAttribute('aria-labelledby');
      controls?.remove();controls=null;
    }
  }
  rail.addEventListener('scroll',()=>{if(!mobile.matches||frame)return;frame=requestAnimationFrame(()=>{frame=null;update()})},{passive:true});
  rail.addEventListener('keydown',event=>{if(!mobile.matches||event.target!==rail||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const current=[...controls.children].findIndex(b=>b.getAttribute('aria-pressed')==='true');go(Math.max(0,Math.min(cards.length-1,current+(event.key==='ArrowRight'?1:-1))))});
  mobile.addEventListener('change',layout);layout();
})();
(()=>{
  const header=document.querySelector('.site-header');
  const host=header?.closest('.shopify-section-group-header-group');
  if(!host)return;
  const mobile=matchMedia('(max-width:760px)');
  const html=document.documentElement;
  const menu=header.querySelector('.mobile-menu');
  const search=document.querySelector('.av-search-dialog');
  const commission=document.querySelector('[data-commission]');
  let lastY=0,distance=0,direction=0,frame=0,away=null;
  function show(visible){
    if(away===!visible)return;
    away=!visible;
    host.classList.toggle('av-header-away',away);
    html.style.setProperty('--av-header-offset',visible?'68px':'0px');
  }
  function pinnedPrice(){
    if(!commission)return false;
    const rect=commission.getBoundingClientRect();
    return rect.top<=68&&rect.bottom>140;
  }
  function update(){
    frame=0;if(!mobile.matches)return;
    const y=Math.max(0,window.scrollY),delta=y-lastY;
    lastY=y;
    if(menu?.open||search?.open||header.contains(document.activeElement)){show(true);distance=0;return;}
    if(y<68){show(true);distance=0;return;}
    if(pinnedPrice()){show(false);distance=0;return;}
    const nextDirection=Math.sign(delta);
    if(!nextDirection)return;
    if(direction!==nextDirection){direction=nextDirection;distance=0;}
    distance+=Math.abs(delta);
    if((direction>0&&distance>=20)||(direction<0&&distance>=12)){show(direction<0);distance=0;}
  }
  function schedule(){if(mobile.matches&&!frame)frame=requestAnimationFrame(update);}
  function setup(){
    lastY=Math.max(0,window.scrollY);distance=0;direction=0;
    if(mobile.matches){const visible=!pinnedPrice();host.classList.add('av-returning-header');html.classList.add('av-returning-ready');show(visible);}
    else{host.classList.remove('av-returning-header','av-header-away');html.classList.remove('av-returning-ready');html.style.removeProperty('--av-header-offset');away=null;}
  }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  header.addEventListener('focusin',()=>{if(mobile.matches)show(true)});
  menu?.addEventListener('toggle',()=>{if(mobile.matches){if(menu.open)show(true);else schedule()}});
  search?.addEventListener('close',schedule);
  mobile.addEventListener('change',setup);
  if(mobile.matches&&(commission||document.querySelector('.pricing-guide')))requestAnimationFrame(()=>requestAnimationFrame(setup));else setup();
})();

